import { z } from 'zod'

export type StrapiID = string | number
export type OrderVariable = string

export type Override = {
  variable: OrderVariable
  value: string | null
}

export const getOverridesDictionary = (overrides?: Override[]) => {
  if (!overrides) {
    return {}
  }
  const entries = overrides.map((o) => [o.variable, o.value] as const)
  return Object.fromEntries(entries)
}

export const StrapiIdSchema = z.number().or(z.string())
